import { Injectable } from '@angular/core';
import { collection, Firestore} from '@angular/fire/firestore';
import { addDoc} from '@firebase/firestore';

@Injectable({providedIn: 'root'})
export class CrudService {

  constructor(
    private firestore: Firestore
  ) { 
  }
  addEmail(email:any) {
    let $emailcoll = collection(this.firestore, 'emails');
    return addDoc($emailcoll, email);
  }
}
